(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-card-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('poudreuce-faq')) {
    customElements.define('poudreuce-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.pdFaqAbort) this.pdFaqAbort.abort();
        this.pdFaqAbort = new AbortController();
        const signal = this.pdFaqAbort.signal;
        this.addEventListener('toggle', (event) => {
          const item = event.target;
          if (!(item instanceof HTMLDetailsElement) || item.closest('poudreuce-faq') !== this || !item.open || this.dataset.singleOpen !== 'true') return;
          this.querySelectorAll('.pd-faq__item[open]').forEach((other) => {
            if (other !== item) other.open = false;
          });
        }, {capture: true, signal});
        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const item = Array.from(this.querySelectorAll('.pd-faq__item')).find((candidate) => candidate.dataset.faqBlock === event.detail.blockId);
            if (item) item.open = true;
          }, {signal});
        }
      }
      disconnectedCallback() {
        if (this.pdFaqAbort) this.pdFaqAbort.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('poudreuce-gift-card')) {
    customElements.define('poudreuce-gift-card', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.setAttribute('data-enhanced', '');
        this.querySelectorAll('[data-js-only]').forEach(element => element.hidden = false);
        this.quantity = this.querySelector('[data-quantity]');
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-media-slide]'));
        this.activeSlide = 0;
        this.addEventListener('change', event => {
          if (event.target.matches('[data-variant-option]')) this.selectVariant(event.target, true);
          if (event.target.matches('[data-quantity]')) this.normalizeQuantity();
          if (event.target.matches('[data-recipient-enable]')) this.updateRecipient();
        }, { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.matches('[data-quantity-minus]')) this.changeQuantity(-1);
          if (button.matches('[data-quantity-plus]')) this.changeQuantity(1);
          if (button.matches('[data-save-button]')) this.toggleSaved();
          if (button.matches('[data-gallery-previous]')) this.showSlide(this.activeSlide - 1);
          if (button.matches('[data-gallery-next]')) this.showSlide(this.activeSlide + 1);
          if (button.matches('[data-gallery-index]')) this.showSlide(Number(button.dataset.galleryIndex));
        }, { signal });
        this.viewport?.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateGallery());
        }, { signal, passive: true });
        this.selectVariant(this.querySelector('[data-variant-option]:checked'), false);
        this.updateRecipient();
        this.readSaved();
        this.updateGallery();
        document.addEventListener('visibilitychange', () => this.syncVideoPlayback(), { signal });
        window.addEventListener('storage', event => {
          if (event.key === 'poudreuce:saved-products') this.readSaved();
        }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.querySelectorAll('video').forEach(video => video.pause());
      }
      selectVariant(option, updateUrl) {
        if (!option) return;
        this.querySelector('[data-current-price]').textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        this.querySelector('[data-add-button]').disabled = !available;
        this.querySelector('[data-add-text]').textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        this.quantity.min = option.dataset.min || '1';
        this.quantity.step = option.dataset.step || '1';
        if (option.dataset.max) this.quantity.max = option.dataset.max;
        else this.quantity.removeAttribute('max');
        this.normalizeQuantity();
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState(history.state, '', url.toString());
          const mediaIndex = this.slides.findIndex(slide => slide.dataset.mediaId && slide.dataset.mediaId === option.dataset.mediaId);
          if (mediaIndex >= 0) this.showSlide(mediaIndex);
        }
      }
      normalizeQuantity() {
        if (!this.quantity) return;
        const min = Number(this.quantity.min) || 1;
        const step = Number(this.quantity.step) || 1;
        const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
        let value = Number(this.quantity.value);
        if (!Number.isFinite(value) || value < min) value = min;
        value = min + Math.round((value - min) / step) * step;
        const alignedMax = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : max;
        value = Math.max(min, Math.min(value, alignedMax));
        this.quantity.value = String(value);
        const minus = this.querySelector('[data-quantity-minus]');
        const plus = this.querySelector('[data-quantity-plus]');
        if (minus) minus.disabled = value <= min;
        if (plus) plus.disabled = value + step > max;
      }
      changeQuantity(direction) {
        this.quantity.value = String(Number(this.quantity.value) + direction * (Number(this.quantity.step) || 1));
        this.normalizeQuantity();
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateRecipient() {
        const checkbox = this.querySelector('[data-recipient-enable]');
        const fields = this.querySelector('[data-recipient-fields]');
        if (!checkbox || !fields) return;
        fields.hidden = !checkbox.checked;
        fields.querySelectorAll('input, textarea').forEach(input => input.disabled = !checkbox.checked);
        const email = fields.querySelector('[data-recipient-email]');
        email.required = checkbox.checked;
        const date = fields.querySelector('[data-recipient-date]');
        const today = new Date();
        const latest = new Date(today);
        latest.setDate(latest.getDate() + 90);
        const dateString = value => `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
        date.min = dateString(today);
        date.max = dateString(latest);
        fields.querySelector('[data-recipient-offset]').value = String(today.getTimezoneOffset());
      }
      readSaved() {
        try {
          const saved = JSON.parse(localStorage.getItem('poudreuce:saved-products') || '[]');
          this.savedProducts = Array.isArray(saved) ? saved.filter(id => typeof id === 'string') : [];
        } catch {
          this.savedProducts = [];
        }
        this.renderSaved(false);
      }
      renderSaved(announce) {
        const button = this.querySelector('[data-save-button]');
        if (!button) return;
        const saved = this.savedProducts.includes(this.dataset.productId);
        const label = saved ? this.dataset.savedLabel : this.dataset.saveLabel;
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('aria-label', label);
        button.title = label;
        if (announce) this.querySelector('[data-save-status]').textContent = label;
      }
      toggleSaved() {
        this.readSaved();
        const id = this.dataset.productId;
        this.savedProducts = this.savedProducts.includes(id) ? this.savedProducts.filter(item => item !== id) : [...this.savedProducts, id];
        try { localStorage.setItem('poudreuce:saved-products', JSON.stringify(this.savedProducts)); } catch {}
        this.renderSaved(true);
      }
      showSlide(index) {
        if (!this.viewport) return;
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        this.viewport.scrollTo({ left: target * this.viewport.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      syncVideoPlayback() {
        this.slides.forEach((slide, index) => {
          const active = index === this.activeSlide && !document.hidden;
          slide.querySelectorAll('video').forEach(video => {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.controls = false;
            video.autoplay = active;
            if (active) {
              if (video.paused) video.play()?.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      }
      updateGallery() {
        if (!this.viewport || !this.viewport.clientWidth) return;
        const previous = this.activeSlide;
        this.activeSlide = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
        this.querySelectorAll('[data-gallery-index]').forEach(button => {
          if (Number(button.dataset.galleryIndex) === this.activeSlide) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        const previousButton = this.querySelector('[data-gallery-previous]');
        const nextButton = this.querySelector('[data-gallery-next]');
        if (previousButton) previousButton.disabled = this.activeSlide === 0;
        if (nextButton) nextButton.disabled = this.activeSlide === this.slides.length - 1;
        this.syncVideoPlayback();
        if (previous !== this.activeSlide) {
          this.slides[previous]?.querySelectorAll('video').forEach(video => video.pause());
          this.slides[previous]?.querySelectorAll('iframe').forEach(frame => frame.src = frame.src);
          this.slides[previous]?.querySelectorAll('model-viewer').forEach(model => model.pause?.());
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poudreuce-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('poudreuce-faq')) {
    customElements.define('poudreuce-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.pdFaqAbort) this.pdFaqAbort.abort();
        this.pdFaqAbort = new AbortController();
        const signal = this.pdFaqAbort.signal;
        this.addEventListener('toggle', (event) => {
          const item = event.target;
          if (!(item instanceof HTMLDetailsElement) || item.closest('poudreuce-faq') !== this || !item.open || this.dataset.singleOpen !== 'true') return;
          this.querySelectorAll('.pd-faq__item[open]').forEach((other) => {
            if (other !== item) other.open = false;
          });
        }, {capture: true, signal});
        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const item = Array.from(this.querySelectorAll('.pd-faq__item')).find((candidate) => candidate.dataset.faqBlock === event.detail.blockId);
            if (item) item.open = true;
          }, {signal});
        }
      }
      disconnectedCallback() {
        if (this.pdFaqAbort) this.pdFaqAbort.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poudreuce-media-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('poudreuce-media-tabs')) {
    customElements.define('poudreuce-media-tabs', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abortController?.abort();
      }
      initialize() {
        this.tabs = Array.from(this.querySelectorAll('[data-pd-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-pd-panel]'));
        const tablist = this.querySelector('[data-pd-tablist]');
        if (!tablist || !this.tabs.length || this.tabs.length !== this.panels.length) return;
        const options = { signal: this.abortController.signal };
        tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', event => {
            event.preventDefault();
            this.activate(index);
          }, options);
          tab.addEventListener('keydown', event => {
            let nextIndex;
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') nextIndex = (index + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this.tabs.length - 1;
            if (event.key === ' ') nextIndex = index;
            if (nextIndex !== undefined) {
              event.preventDefault();
              this.activate(nextIndex, true);
            }
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail?.blockId;
          const block = Array.from(this.querySelectorAll('[data-pd-block-id]')).find(item => item.dataset.pdBlockId === blockId);
          const panel = block?.closest('[data-pd-panel]');
          const index = this.panels.indexOf(panel);
          if (index >= 0) this.activate(index);
        }, options);
        this.setAttribute('data-enhanced', '');
        const current = this.tabs.findIndex(tab => tab.dataset.pdTabId === this.activeTabId);
        const configured = this.tabs.findIndex(tab => tab.dataset.pdKey === this.dataset.defaultTab);
        this.activate(current >= 0 ? current : configured >= 0 ? configured : 0);
      }
      activate(index, moveFocus = false) {
        this.activeTabId = this.tabs[index].dataset.pdTabId;
        this.tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[position].hidden = !selected;
          this.panels[position].querySelectorAll('video').forEach(video => {
            if (!selected || matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
            else if (video.autoplay) video.play().catch(() => {});
          });
        });
        if (moveFocus) this.tabs[index].focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
